import {
    Box,
    Button,
    Center,
    Container,
    Divider,
    Heading,
    HStack,
    SimpleGrid,
    Stat,
    StatLabel,
    StatNumber,
    Text,
    useColorModeValue
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { merge, tap } from "rxjs";
import Web3Service from "../core/web3.service";

function bagForToken(token_: number): string {
    if (token_ > 65) return 'bronze'; // bronze
    if (token_ > 15) return 'silver'; // silver
    return 'gold'
}

const GalleryView: React.FC = (props) => {
    const web3Service = Web3Service.shared();

    const [account, setAccount] = useState<string | undefined>(undefined);
    const [tokens, setTokens] = useState<number[]>([]);
    const [bags, setBags] = useState<number[]>([]);
    const [boxes, setBoxes] = useState<number[]>([]);

    useEffect(() => {
        web3Service.getUserTokens(undefined);
        web3Service.getUserBags(undefined);
        web3Service.getUserBoxes(undefined);

        const account$ = web3Service.account$.pipe(
            tap((account) => {
                setAccount(account);
            })
        );

        const tokens$ = web3Service.tokens$.pipe(
            tap((tokens) => {
                setTokens(tokens);
            })
        );

        const bags$ = web3Service.bags$.pipe(
            tap((tokens) => {
                console.log(bags.map(x => Number(x)))
                setBags(tokens);
            })
        );

        const boxes$ = web3Service.boxes$.pipe(
            tap((tokens) => {
                setBoxes(tokens);
            })
        );

        const subscription = merge(
            tokens$,
            bags$,
            boxes$,
            account$
        ).subscribe();

        return () => {
            subscription.unsubscribe();
        };
    }, [account]);

    let emptyView = <>
        <Center mt={8}>
            <Text maxW={'2xl'}>You do not own any NFTs</Text>
        </Center>
    </>

    let content = <>
        <SimpleGrid
            columns={{ base: 1, md: 1 }}
            spacing={{ base: 4, md: 8 }}
            my={{ base: 4, md: 8 }}
            mx={"auto"}
            px={4}
            maxW={"6xl"}
        >
            <Stat bg={useColorModeValue(
                "rgba(247, 250, 252, 0.5)",
                "rgba(23, 25, 35, 0.5)"
            )}
                rounded={"xl"}
                boxShadow={"md"}
                p={4}>
                <StatLabel>Owned CMM</StatLabel>
                <StatNumber fontSize={{ base: 'sm', md: 'md' }}>{tokens.length}</StatNumber>
            </Stat>
        </SimpleGrid>

        <SimpleGrid
            columns={{ base: 1, md: 1 }}
            spacing={{ base: 4, md: 6 }}
            my={{ base: 4, md: 8 }}
            mx={"auto"}
            maxW={"256px"}
        >
            {tokens.length > 0 ? <video muted autoPlay loop controls>
                <source src="https://bafybeiazixbji2ct4db4dflmrnztrthn2clqbyqy5hfb7y55tdxhrt426a.ipfs.dweb.link/1.mp4" type="video/mp4" />
                <img src="https://bafybeiazixbji2ct4db4dflmrnztrthn2clqbyqy5hfb7y55tdxhrt426a.ipfs.dweb.link/1.png" title="Your browser does not support HTML video." />
            </video> : emptyView}
        </SimpleGrid>

        <Divider py={4} />

        <SimpleGrid
            columns={{ base: 1, md: 1 }}
            spacing={{ base: 4, md: 8 }}
            my={{ base: 4, md: 8 }}
            mx={"auto"}
            px={4}
            maxW={"6xl"}
        >
            <Stat bg={useColorModeValue(
                "rgba(247, 250, 252, 0.5)",
                "rgba(23, 25, 35, 0.5)"
            )}
                rounded={"xl"}
                boxShadow={"md"}
                p={4}>
                <StatLabel>Owned Money Bag</StatLabel>
                <StatNumber fontSize={{ base: 'sm', md: 'md' }}>{bags.length}</StatNumber>
            </Stat>
        </SimpleGrid>

        {bags.length > 0 ?
            <SimpleGrid
                columns={{ base: 1, md: 3 }}
                spacing={{ base: 4, md: 6 }}
                my={{ base: 4, md: 8 }}
                mx={"auto"}
                maxW={"2xl"}
            >
                {
                    bags.map(token => (
                        <video muted autoPlay loop controls>
                            <source src={`https://bafybeidqj5olde3dhpx6cr2ygolevg6c7oxtccv3l7oghtteihr2j3wrn4.ipfs.dweb.link/${bagForToken(Number(token))}.mp4`} type="video/mp4" />
                            <img src={`https://bafybeidqj5olde3dhpx6cr2ygolevg6c7oxtccv3l7oghtteihr2j3wrn4.ipfs.dweb.link/${bagForToken(Number(token))}.png`} title="Your browser does not support HTML video." />
                        </video>
                    ))
                }
            </SimpleGrid>
            : emptyView}

        <Divider py={4} />

        <SimpleGrid
            columns={{ base: 1, md: 1 }}
            spacing={{ base: 4, md: 8 }}
            my={{ base: 4, md: 8 }}
            mx={"auto"}
            px={4}
            maxW={"6xl"}
        >
            <Stat bg={useColorModeValue(
                "rgba(247, 250, 252, 0.5)",
                "rgba(23, 25, 35, 0.5)"
            )}
                rounded={"xl"}
                boxShadow={"md"}
                p={4}>
                <StatLabel>Owned Safe Box</StatLabel>
                <StatNumber fontSize={{ base: 'sm', md: 'md' }}>{boxes.length}</StatNumber>
            </Stat>
        </SimpleGrid>

        <SimpleGrid
            columns={{ base: 1, md: 1 }}
            spacing={{ base: 4, md: 6 }}
            my={{ base: 4, md: 8 }}
            mx={"auto"}
            maxW={"256px"}
        >
            {tokens.length > 0 ? <video muted autoPlay loop controls>
                <source src="https://copper-melodic-parrotfish-222.mypinata.cloud/ipfs/QmP9fWzbg9VYY6tPWbJMuxzfBJhnMsVjR5pMxGn3ezgLXf/0.mp4" type="video/mp4" />
                <img src="https://copper-melodic-parrotfish-222.mypinata.cloud/ipfs/QmP9fWzbg9VYY6tPWbJMuxzfBJhnMsVjR5pMxGn3ezgLXf/0.png" title="Your browser does not support HTML video." />
            </video> : emptyView}
        </SimpleGrid>
    </>

    let connectWallet = <>
        <Container>
            <Center mt={8}>
                <Text maxW={'2xl'}>Connect Wallet to see your CMM NFTs</Text>
            </Center>
            <Center mt={8}>
                <Button size={{ base: 'sm', sm: 'sm', md: 'md' }} onClick={web3Service.toggleConnect}>
                    {"Connect Wallet"}
                </Button>
            </Center>
        </Container>
    </>

    return (
        <>
            <HStack pt={8} minW={360} maxW={"xl"} margin={"auto"}>
                <Divider borderWidth={2} />
                <Heading w={'100%'} textColor={'rgb(218, 165, 32)'} textAlign={"center"} fontFamily={"Sedgwick Ave Display"} fontSize={'4xl'}>MY NFTs</Heading>
                <Divider borderWidth={2} />
            </HStack>
            <Center my={8}>
                <Box>
                    {account ? content : connectWallet}
                </Box>
            </Center>
        </>
    );
};

export default GalleryView;
